import React from "react";
import styled from "styled-components";
import { FaCertificate, FaUserGraduate, FaShieldAlt, FaAward } from "react-icons/fa";
import { QRCodeCanvas } from "qrcode.react";
import {
  FaChartLine,
  FaIndustry,
  FaTasks,
  FaFileInvoice,
  FaLaptopCode,
  FaCloud,
} from "react-icons/fa";




const certifications = [
    "Tally Professional",
    "Tally Prime with GST Fundamentals",
    "Financial Markets and Services",
    "TDL Essentials (Tally Definition Language)",
    "TDS Using Tally",
    "Payroll Using Tally",
    "Accounting Basics Crash Course",
];
const trustPoints = [
  {
    icon: FaChartLine,
    title: "Career Advancement",
    description:
      "Enhance your career prospects with Tally certification, unlocking opportunities in finance, auditing, and business analysis.",
  },
  {
    icon: FaIndustry,
    title: "Industry Recognized",
    description:
      "Master industry-standard accounting practices with Tally certification, ensuring your skills are highly valued by businesses.",
  },
  {
    icon: FaTasks,
    title: "Comprehensive Skills",
    description:
      "Gain comprehensive skills with our certification, unlocking opportunities in bookkeeping, financial management, and business accounting.",
  },
];
const keyOfferings = [
  {
    icon: FaFileInvoice,
    title: "GST Compliance through Simulation",
    description:
      "Navigate business tax intricacies with hands-on experience in GST compliance, returns, e-Way bills, and e-Invoicing.",
  },
  {
    icon: FaLaptopCode,
    title: "Online Internships",
    description:
      "Discover Tally online internships aligned with NEP 2020, offering experiential learning for real-world success.",
  },
  {
    icon: FaCloud,
    title: "TallyPrime on Cloud",
    description:
      "Experience hands-on training with TallyPrime on Cloud, giving access to licensed software for comprehensive learning.",
  },
];


const badgeData = [
    {
        label: "Certified",
        icon: FaCertificate,
    },
    {
        label: "Industry Ready",
        icon: FaUserGraduate,
    },
    {
        label: "Verified",
        icon: FaShieldAlt,
    },
    {
        label: "Professional",
        icon: FaAward,
    },
];


export default function Certifications() {
    return (
        <Section>
            <Header>
                <Subtitle>PROFESSIONAL CERTIFICATIONS</Subtitle>
                <Title>Our Certification Programs</Title>
            </Header>

            <CertificateGrid>
                {certifications.map((cert, index) => (
                    <CertificateCard key={index}>
                        <InnerBorder>
                            <BadgeRow>
                                {badgeData.map((badge, i) => {
                                    const Icon = badge.icon;
                                    return (
                                        <Badge key={i}>
                                            <BadgeIcon>
                                                <Icon size={16} />
                                            </BadgeIcon>
                                            <BadgeText>{badge.label}</BadgeText>
                                        </Badge>
                                    );
                                })}
                            </BadgeRow>


                            <CertificateType>COURSE CERTIFICATE</CertificateType>
                            <CertificateTitle>{cert}</CertificateTitle>

                            <IssuedText>Issued by</IssuedText>
                            <IssuedName>LK Education</IssuedName>

                            <Description>
                                This certificate confirms the successful completion of the{" "}
                                <strong>{cert}</strong> program with practical and industry-oriented
                                training.
                            </Description>

                            <FooterRow>
                                <Signature>
                                    <SignLine />
                                    <span>Authorized Signature</span>
                                </Signature>

                                <Meta>
                                    <QRCodeWrapper>
                                        <QRCodeCanvas
                                            value={`LK-CERT-${index + 1024}`}
                                            size={60}
                                            bgColor="#ffffff"
                                            fgColor="#000000"
                                            level="H"
                                        />

                                    </QRCodeWrapper>

                                    <span>Issued: {new Date().getFullYear()}</span>
                                    <span>ID: LK-{index + 1024}</span>
                                </Meta>
                            </FooterRow>

                        </InnerBorder>
                    </CertificateCard>
                ))}
            </CertificateGrid>
            <TrustSection>
  <TrustGrid>
    {trustPoints.map((item, i) => {
      const Icon = item.icon;
      return (
        <TrustCard key={i}>
          <TrustIcon>
            <Icon size={28} />
          </TrustIcon>
          <TrustTitle>{item.title}</TrustTitle>
          <TrustDesc>{item.description}</TrustDesc>
        </TrustCard>
      );
    })}
  </TrustGrid>

  <OfferingsHeader>Key Offerings</OfferingsHeader>

  <TrustGrid>
    {keyOfferings.map((item, i) => {
      const Icon = item.icon;
      return (
        <TrustCard key={i}>
          <TrustIcon>
            <Icon size={28} />
          </TrustIcon>
          <TrustTitle>{item.title}</TrustTitle>
          <TrustDesc>{item.description}</TrustDesc>
        </TrustCard>
      );
    })}
  </TrustGrid>
</TrustSection>

        </Section>
    );
}
const Section = styled.section`
  padding: 80px 20px;
  background: #f4f2ff;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 60px;
`;

const Subtitle = styled.p`
  letter-spacing: 2px;
  font-size: 13px;
  color: #6b6b6b;
  margin-bottom: 8px;
`;

const Title = styled.h2`
  font-size: 36px;
  font-weight: 700;
  color: #111;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const CertificateGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 40px;
  max-width: 1300px;
  margin: auto;
`;

const CertificateCard = styled.div`
  background: #ffffff;
  border-radius: 20px;
  padding: 14px;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.08);
`;

const InnerBorder = styled.div`
  border: 3px solid #111;
  border-radius: 16px;
  padding: 32px 26px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const BadgeRow = styled.div`
  display: flex;
  gap: 14px;
  justify-content: center;
  margin-bottom: 24px;
`;

const Badge = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 2px dashed #6a5cff;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;
  padding: 6px;
`;


const BadgeIcon = styled.div`
  color: #6a5cff;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
`;



const BadgeText = styled.span`
  font-size: 9px;
  font-weight: 600;
  color: #6a5cff;
  line-height: 1.2;

  word-break: break-word;
  white-space: normal;
`;


const CertificateType = styled.p`
  text-align: center;
  font-size: 12px;
  letter-spacing: 1.5px;
  color: #777;
  margin-bottom: 6px;
`;

const CertificateTitle = styled.h3`
  text-align: center;
  font-size: 26px;
  font-weight: 700;
  color: #000;
  margin-bottom: 18px;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const IssuedText = styled.p`
  text-align: center;
  font-size: 12px;
  color: #777;
`;

const IssuedName = styled.p`
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 18px;
`;

const Description = styled.p`
  text-align: center;
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin-bottom: 28px;
`;

const FooterRow = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const Signature = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  span {
    font-size: 11px;
    color: #777;
  }
`;

const SignLine = styled.div`
  width: 120px;
  height: 2px;
  background: #000;
`;

const Meta = styled.div`
  text-align: right;
  font-size: 11px;
  color: #777;
`;
const QRCodeWrapper = styled.div`
  margin-bottom: 6px;
`;
const TrustSection = styled.div`
  margin-top: 100px;
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
`;

const TrustGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
  margin-bottom: 80px;
`;

const TrustCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 32px 26px;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.06);
`;

const TrustIcon = styled.div`
  color: #6a5cff;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
`;

const TrustTitle = styled.h4`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #111;
`;

const TrustDesc = styled.p`
  font-size: 14px;
  line-height: 1.6;
  color: #555;
`;

const OfferingsHeader = styled.h3`
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 50px;
  color: #111;
`;


